import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-account-sucess',
  templateUrl: './delete-account-sucess.component.html',
  styleUrl: './delete-account-sucess.component.css'
})
export class DeleteAccountSucessComponent {

}
